// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import asyncMergeSort from 'async-merge-sort'

import { statusMapper } from '../common'

export const sortData = (arr, { asc, col }, callback) => {
  const sorter = (a, b, cb) => {
    let av
    let bv

    switch (col) {
      case 'antenna' :
        // model number is at the antenna level,
        // not antenna-spec
        av = a[col].modelNumber.toLowerCase()
        bv = b[col].modelNumber.toLowerCase()
        break

      case 'status' :
        av = statusMapper(a[col])
        bv = statusMapper(b[col])
        break

      default :
        // TODO - once using real antenna data, if all values
        // are not nullable, remove the conditionals below
        av = a[col] === null ? '' : a[col].toString().toLowerCase()
        bv = b[col] === null ? '' : b[col].toString().toLowerCase()
        break
    }

    if (asc) {
      return cb(null, (av >= bv) ? 1 : -1)
    } else {
      return cb(null, (av <= bv) ? 1 : -1)
    }
  }

  return asyncMergeSort(arr, sorter, callback)
}

// just sort by antenna code
export const getSortColByFormValues = () => 'antennaCode'
